import { loadCaptcha, validateForm } from '../_global';
import { toggleLoader } from '../_functions';

const submitEvent = async event => {
  event.preventDefault();

  const $form = event.currentTarget;
  const $button = $form.querySelector('button[type=submit]');
  const submitUrl = '/callback';

  try {
    toggleLoader($button, true);

    await validateForm($form);
    await loadCaptcha(event.target);

    const params = {
      type: 'Question',
      url: window.location.href,
      name: document.getElementById('modalFeedbackName').value,
      email: document.getElementById('modalFeedbackEmail').value,
      company: document.getElementById('modalFeedbackCompany').value,
      text: document.getElementById('modalFeedbackText').value,
      "g-recaptcha-response": $form.querySelector('[name=g-recaptcha-response]').value
    };

    const response = await fetch(submitUrl, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'Content-Type': 'text/html; charset=UTF-8'
      },
      body: JSON.stringify(params)
    });

    const data = await response.text();

    if (data === 'success') {
      document.querySelector('#modal_feedback .modal-header').innerHTML = '<div class="modal-title">We’ve received your request!</div>';

      $form.innerHTML = `
        <div class="alert alert-success mb-25">An engineer will contact you shortly. Thank you!</div>
        <button type="button" class="btn btn-primary btn-block" data-bs-dismiss="modal">Continue</button>
      `;

      gTagConversion();
    } else {
      throw new Error(`The server respond was: ${data}`);
    }
  } catch (err) {
    const notification = document.createElement('div');
    notification.classList.add('text-danger');
    notification.classList.add('mb-10');
    notification.innerText = 'There was an error processing your request. Please, try again later.';

    $form.prepend(notification);
    toggleLoader($button, false);
    console.error(err);
  }
};

function gTagConversion() {
  try {
    gtag('event', 'conversion', { 'send_to': 'AW-881324230/OxyHCMKQppQDEMbhn6QD' });
  } catch (e) {
    console.error(e);
  }
}

async function modalFeedback(state) {
  const { default: Modal } = await import('bootstrap/js/dist/modal');

  const $modal = document.createElement('div');

  $modal.innerHTML = `
  <div id="modal_feedback" class="modal fade" data-bs-backdrop="true" data-bs-keyboard="true" aria-hidden="true" tabindex="-1">
    <div class="modal-dialog modal-sm text-dark modal-dialog-centered">
      <button type="button" class="close icon icon-close" data-bs-dismiss="modal">Close</button>

      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">Ask an Expert</div>
          <div class="modal-subtitle">Our experts will be happy to assist you</div>
        </div>

        <form id="formFeedback" method="POST" class="modal-body">
          <div class="form-group">
            <label class="form-label" for="modalFeedbackName">Your Name</label>
            <input type="text" class="form-control" id="modalFeedbackName" required />
          </div>

          <div class="form-group">
            <label class="form-label" for="modalFeedbackEmail">E-mail</label>
            <input type="email" class="form-control" id="modalFeedbackEmail" required />
          </div>

          <div class="form-group">
            <label class="form-label" for="modalFeedbackCompany">Company Name</label>
            <input type="text" class="form-control" id="modalFeedbackCompany" />
          </div>

          <div class="form-group">
            <label class="form-label" for="modalFeedbackText">Message</label>
            <textarea class="form-control" id="modalFeedbackText" rows="4" required placeholder="Include as many details as you can about your project. We respond within a few minutes."></textarea>
          </div>

          <button type="submit" class="btn btn-primary btn-block">Submit</button>
          
          <p style="margin-top: 10px; opacity:0.5; font-size: 13px; text-align: right;">
            By clicking submit, I agree to allow this website to store my data so they can respond to my inquiry.
            <a href="/policies" target="__blank">Privacy Policy</a>
            apply.
          </p>
        </form>
      </div>
    </div>
  </div>`;

  document.body.append($modal);

  const modal = new Modal(document.getElementById('modal_feedback'));

  modal._element.addEventListener('hidden.bs.modal', () => {
    $modal.remove();
  });

  if (state === 'show') {
    modal.show();
    document.getElementById('formFeedback').addEventListener('submit', submitEvent);
  } else {
    document.getElementById('formFeedback').removeEventListener('submit', submitEvent);
    modal.hide();
  }
}

export { modalFeedback };
